import { defineMessages } from 'react-intl'

export const loyaltyPaymentMethodEarnSummaryMessages = defineMessages({
  appliedChip: {
    id: 'sQcLHN0s2rA8pbnatOTW',
    defaultMessage: 'Bonus {loyaltyProgramName} Points applied',
    description: 'Pill in the checkout summary and earning points modal when the chosen payment method earns bonus loyalty points',
  },
  earnFromWithStatusCredits: {
    id: 'R8-tKDb9SbDZKRRkPyxE',
    defaultMessage: 'You’ll earn from <bold>{points} Société {pointsUnit} + {statusCredits}</bold>',
    description: 'Checkout summary earn line before a payment method is chosen, with the minimum Société points and status credits',
  },
  earnFrom: {
    id: 'WtiidqWrgUlPgJde177L',
    defaultMessage: 'You’ll earn from <bold>{points} Société {pointsUnit}</bold>',
    description: 'Checkout summary earn line before a payment method is chosen, with the minimum Société points and no status credits',
  },
  earnWithStatusCredits: {
    id: 'Hq7MrnFHaCE0y46XITU8',
    defaultMessage: 'You’ll earn <bold>{points} Société {pointsUnit} + {statusCredits}</bold>',
    description: 'Checkout summary earn line for the chosen payment method, with the Société points and status credits earned',
  },
  earn: {
    id: 'geA1vqezNgosApZ2sjOr',
    defaultMessage: 'You’ll earn <bold>{points} Société {pointsUnit}</bold>',
    description: 'Checkout summary earn line for the chosen payment method, with the Société points earned and no status credits',
  },
  dependsOnPayment: {
    id: 'rRKeNQ6-kybQ250t9sJU',
    defaultMessage: 'The points you earn depend on how you pay. <learnMore>Learn more</learnMore>',
    description: 'Checkout summary note under the earn line explaining loyalty points vary by payment method, with a link to the earning details',
  },
})

export const loyaltyPaymentMethodEarnModalMessages = defineMessages({
  paymentMethodBonus: {
    id: 'k17g7_d25vho7lNtB4r8',
    defaultMessage: 'Includes bonus points from paying with eligible payment method.',
    description: 'Green banner in the checkout loyalty points earning modal when the bonus points come only from paying with a low cost payment method',
  },
  promotionAndPaymentMethodBonus: {
    id: '9jgdQeHKG1NuD6mgRrJF',
    defaultMessage: 'Includes bonus points from {promotionCount, plural, one {a {loyaltyProgramName} Points promotion} other {{loyaltyProgramName} Points promotions}} and paying with eligible payment method.',
    description: 'Green banner in the checkout loyalty points earning modal when the bonus points come from one or more bonus points promotions and a low cost payment method',
  },
  multiplePromotionsBonus: {
    id: 'h0SD7luwhQkiP657aDwx',
    defaultMessage: 'Includes bonus points from {loyaltyProgramName} Points promotions',
    description: 'Green banner in the checkout loyalty points earning modal when the bonus points come only from more than one bonus points promotion',
  },
  multiplierCampaignBonus: {
    id: 'fO10H3wIHUlkPL3sFr2H',
    defaultMessage: 'Includes bonus points from the {multiplier}x {loyaltyProgramName} Points promotion',
    description: 'Green banner in the checkout loyalty points earning modal when the bonus points come only from a double or triple points campaign, e.g. 2x',
  },
  campaignBonus: {
    id: 'UoAkPawxdYdoY3QQZJEe',
    defaultMessage: 'Includes bonus points from the {loyaltyProgramName} Points promotion',
    description: 'Green banner in the checkout loyalty points earning modal when the bonus points come only from a fixed bonus points campaign',
  },
  dependsOnPayment: {
    id: 'p1nQGoolhGtxDv-9t9sX',
    defaultMessage: 'The points you earn depend on how you pay. See below which methods earn {multiplier}x {loyaltyProgramName} Points and which earn base {loyaltyProgramName} Points.',
    description: 'Text in the loyalty points earning modal introducing the lists of payment methods that earn a multiple of points or the base rate',
  },
  fromPoints: {
    id: 'yG8nwO7DZsqyDQ74pTh6',
    defaultMessage: 'From {points}',
    description: 'Points value in the loyalty points earning modal table before a payment method is chosen, showing the minimum points',
  },
  creditingFootnote: {
    id: 'pIOU_AEMy23-TFst2k52',
    defaultMessage: 'Points are credited the day after your trip. For Shop orders, your final points balance is credited 30–40 days after confirmation and may differ from the estimate shown.',
    description: 'Footnote in the loyalty points earning modal explaining when points are credited for trips and Shop orders',
  },
  ineligibleFootnote: {
    id: 'GEpJWSi2FMJmLtwVnV1u',
    defaultMessage: 'You won’t earn points on amounts paid with points, only on the remaining dollar amount. Amounts covered by promotional codes, pre-launch credits and credits from cancellations made before {loyaltyProgramName} launched don’t earn points either.',
    description: 'Footnote in the loyalty points earning modal explaining which payments do not earn loyalty points',
  },
  paymentMethodFootnote: {
    id: 'DU9T5tb_u_kP5d3YgDkY',
    defaultMessage: 'To earn {multiplier}x points, pay the entire order with eligible methods. If any part is paid with an ineligible method, the whole order earns base points. Later payments for date changes, add-ons or upgrades inherit the original order’s earn rate, regardless of payment method.',
    description: 'Footnote in the loyalty points earning modal explaining the whole order must be paid with eligible methods to earn the multiple of points',
  },
})
